import React from 'react';
import { MailIcon, InstagramIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-black py-12 px-4" data-id="element-50">
      <div className="max-w-4xl mx-auto text-center space-y-4" data-id="element-51">
        <p className="font-display text-xl text-mint font-semibold" data-id="element-52">
          MegaPack — SaludentuPlato™
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 text-sm" data-id="element-53">
          <a href="mailto:soporte@saludentuplato.com" className="flex items-center gap-2 text-white/50 hover:text-mint transition-colors" data-id="element-54">
            <MailIcon className="w-4 h-4" data-id="element-55" />
            soporte@saludentuplato.com
          </a>
          <a href="https://instagram.com/saludentuplato.oficial" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-white/50 hover:text-mint transition-colors" data-id="element-56">
            <InstagramIcon className="w-4 h-4" data-id="element-57" />
            @saludentuplato.oficial
          </a>
        </div>
        <p className="text-xs text-white/30" data-id="element-58">
          © SaludentuPlato™ 2026 — Todos los derechos reservados. Prohibida la
          reproducción y redistribución sin autorización expresa.
        </p>
      </div>
    </footer>;
}